<template>
	<div v-cloak>
		<div :style="{'--current-color': theme}">
			<el-container class="admin-container">
				<AdminMenu :style="'display:' + (topNav?'none':'block')"></AdminMenu>
				<el-container v-if="hackReset">
					<AdminHeader></AdminHeader>
					<top-nav style="position:absolute;top:60px;background-color:#E2E2E2;" id="topmenu-container"
						class="topmenu-container" v-if="topNav" />
					<el-main class="admin-main"
						:style="{'padding':topNav?'0px 0 0 0px':'0px 0 0 240px','top':topNav?'125px':'0px'}">
						<div class="main-content" :class="[topNav?'tableBox9Npt':'tableBox9pt']">
							<router-view></router-view>
						</div>
					</el-main>
				</el-container>
			</el-container>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/common.css"
	import "@/assets/css/home/index.css"
	import AdminHeader from "@/components/common/header"
	/* import AdminFooter from "@/components/common/footer";*/
	import AdminMenu from "@/components/common/menu"
	import store from '@/store'
	import {
		mapState
	} from 'vuex'
	import TopNav from '@/components/TopNav'

	export default {
		name: 'index',
		components: {
			AdminHeader,
			/* AdminFooter,*/
			AdminMenu,
			TopNav,
		},
		data() {
			return {
				hackReset: true,
				zoom: 100,
			};
		},
		methods: {
			loadData() {
				//window.reload();
			},
		},
		computed: {
			// haha() {
			//   return this.$store.getters.getSessionIdChange
			// }
			...mapState({
				theme: state => state.settings.theme,
				sideTheme: state => state.settings.sideTheme,
				sidebar: state => state.app.sidebar,
				device: state => state.app.device,
				needTagsView: state => state.settings.tagsView,
				fixedHeader: state => state.settings.fixedHeader,
				topNav: state => state.settings.topNav,
			}),
			/* setting: {
				get() {
					return this.$store.state.settings.showSettings
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'showSettings',
						value: val
					})
				}
			}, */
			/* topNav: {
				get() {
					return this.$store.state.settings.topNav
				}
			} */
		},
		/* watch: {
		  haha: function (newVal, oldVal) {
		    //插入需要在仓库数据变化时做的逻辑处理
		    this.$router.push({
		      path: '/'
		    });

		  }
		}, */
		created() {
			this.onUrl = this.$route.path;
			var that = this;
			// window.addEventListener("visibilitychange", function () { //这个方法是监测浏览器窗口发生变化的时候执行
			//   if (document.hidden == false && that.$store.getters.getSessionIdChange != localStorage.getItem('SessionId')) {
			//     that.$store.commit('setSessionIdChange', localStorage.getItem('SessionId'));
			//   }
			// });
			/*window.onresize = () => {
			  return (() => {
			    //pThis.zoom = 100*document.body.clientHeight/1200;
			    pThis.zoom = 100 * window.innerHeight / 853;      //853为设计页面时根据相应设置的适当分辨率高度值而定
			    //pThis.zoom = 100*document.body.clientWidth/1920;
			  })()
			};*/
		}
	}
</script>
<style>
	[v-cloak] {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue